import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { api } from '../../api';
import { useAuth } from '../../context/AuthContext';
import './Admin.css';

export default function Dashboard() {
  const { user } = useAuth();
  const [stats, setStats] = useState({ dogs: [], events: [], inquiries: [] });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    Promise.all([
      api.admin.getAllDogs(),
      api.admin.getAllEvents(),
      api.admin.getInquiries(),
    ]).then(([dogs, events, inquiries]) => {
      setStats({ dogs, events, inquiries });
    }).finally(() => setLoading(false));
  }, []);

  const dogsByStatus = (status) => stats.dogs.filter(d => d.status === status).length;
  const newInquiries = stats.inquiries.filter(i => i.status === 'new').length;

  const cards = [
    { icon: '🐕', label: 'Available Dogs',   value: dogsByStatus('available'), to: '/admin/dogs',      color: 'var(--navy)'  },
    { icon: '⏳', label: 'Pending Adoption', value: dogsByStatus('pending'),   to: '/admin/dogs',      color: 'var(--gold)'  },
    { icon: '🏠', label: 'Adopted',          value: dogsByStatus('adopted'),   to: '/admin/dogs',      color: '#28a745'      },
    { icon: '📋', label: 'New Inquiries',    value: newInquiries,              to: '/admin/inquiries', color: 'var(--red)'   },
    { icon: '📅', label: 'Upcoming Events',  value: stats.events.length,       to: '/admin/events',    color: '#6f42c1'      },
    { icon: '🐾', label: 'Total Dogs',       value: stats.dogs.length,         to: '/admin/dogs',      color: 'var(--tan)'   },
  ];

  return (
    <div className="admin-page">
      <div className="admin-page__header">
        <div>
          <h1 className="admin-page__title">Dashboard</h1>
          <p className="admin-page__subtitle">Welcome back, {user?.name}!</p>
        </div>
        <Link to="/admin/dogs/new" className="btn btn-primary">+ Add Dog</Link>
      </div>

      {loading ? (
        <div className="loading-center"><div className="spinner" /></div>
      ) : (
        <>
          <div className="dashboard-stats">
            {cards.map(card => (
              <Link to={card.to} key={card.label} className="stat-card">
                <div className="stat-card__icon" style={{ background: card.color }}>{card.icon}</div>
                <div className="stat-card__value">{card.value}</div>
                <div className="stat-card__label">{card.label}</div>
              </Link>
            ))}
          </div>

          {/* Recent inquiries */}
          {stats.inquiries.length > 0 && (
            <div className="admin-section">
              <div className="admin-section__header">
                <h2>Recent Inquiries</h2>
                <Link to="/admin/inquiries" className="admin-link">View all →</Link>
              </div>
              <div className="admin-table-wrap">
                <table className="admin-table">
                  <thead>
                    <tr>
                      <th>Applicant</th>
                      <th>Dog</th>
                      <th>Status</th>
                      <th>Date</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    {stats.inquiries.slice(0, 5).map(inq => (
                      <tr key={inq.id}>
                        <td><strong>{inq.first_name} {inq.last_name}</strong><br /><small>{inq.email}</small></td>
                        <td>{inq.dog_name || '—'}</td>
                        <td><span className={`badge badge-${inq.status === 'new' ? 'new' : inq.status === 'approved' ? 'available' : 'pending'}`}>{inq.status}</span></td>
                        <td>{new Date(inq.created_at).toLocaleDateString()}</td>
                        <td><Link to="/admin/inquiries" className="admin-link">View</Link></td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          )}

          {/* Dogs needing attention */}
          {newInquiries > 0 && (
            <div className="admin-alert">
              <span>🔔</span>
              <span>You have <strong>{newInquiries} new inquiry{newInquiries > 1 ? 'ies' : ''}</strong> waiting for review.</span>
              <Link to="/admin/inquiries" className="btn btn-primary" style={{ padding: '6px 16px', fontSize: '0.85rem' }}>Review Now</Link>
            </div>
          )}
        </>
      )}
    </div>
  );
}
